import './PrivacyPolicy.css';

const PrivacyPolicy = () => {
  return (
    <div className="privacy-policy-page">
      <div className="container">
        <div className="privacy-content">
          <h1>Tahoe Mountain Cars Privacy Policy</h1>
          <p className="effective-date"><strong>Effective Date: May 16, 2025</strong></p>
          
          <p className="intro">
            Tahoe Mountain Cars ("we", "our", or "us") respects your privacy and is committed to 
            protecting your personal information. This Privacy Policy explains how we collect, use, 
            and disclose your information when you visit our website, www.tahoemountaincars.com 
            (the "Site") and use our services.
          </p>

          <section className="policy-section">
            <h2>1. Information We Collect</h2>
            <p>We collect the following types of information:</p>
            
            <h3>Personal Information:</h3>
            <ul>
              <li>Email address</li>
              <li>Phone number (if provided)</li>
              <li>Zip code or location information</li>
              <li>Vehicle preferences or survey responses</li>
              <li>Any other information you voluntarily provide via forms, emails, or during communications</li>
            </ul>

            <h3>Usage Information:</h3>
            <ul>
              <li>IP address</li>
              <li>Browser type</li>
              <li>Device identifiers</li>
              <li>Pages visited and referring URLs</li>
              <li>Time and date of visit</li>
            </ul>

            <h3>Cookies and Tracking:</h3>
            <p>
              We may use cookies and similar tracking technologies to enhance user experience and 
              analyze web traffic.
            </p>
          </section>

          <section className="policy-section">
            <h2>2. How We Use Your Information</h2>
            <p>We use the information we collect to:</p>
            <ul>
              <li>Respond to inquiries or customer support requests</li>
              <li>Provide updates about new vehicles, offers, or company news</li>
              <li>Understand customer preferences and improve our offerings</li>
              <li>Fulfill any legal or safety obligations</li>
            </ul>
            <p className="note">
              <strong>Note:</strong> As a private rental agency, we do not currently collect payment 
              or driver's license information directly through the Site. Rental transactions are handled 
              via platforms such as Turo (if applicable), which have their own privacy policies.
            </p>
          </section>

          <section className="policy-section">
            <h2>3. Sharing Your Information</h2>
            <p><strong>We do not sell your personal information.</strong></p>
            <p>
              We may share your data only with trusted third parties who help us operate the website 
              or communicate with you (such as email marketing platforms), and only for business purposes.
            </p>
            <p>We may also share data:</p>
            <ul>
              <li>To comply with legal obligations</li>
              <li>To protect the rights or safety of users and the public</li>
              <li>In the event of a business transfer (e.g. merger or acquisition)</li>
            </ul>
          </section>

          <section className="policy-section">
            <h2>4. Third-Party Links</h2>
            <p>
              Our Site may include links to third-party sites (such as Turo listings or social media). 
              We are not responsible for the privacy practices or content of those external sites.
            </p>
          </section>

          <section className="policy-section">
            <h2>5. Your Rights and Choices</h2>
            <p>You may:</p>
            <ul>
              <li>Unsubscribe from our mailing list at any time</li>
              <li>Request to access or delete the personal information we have about you</li>
              <li>Disable cookies in your browser settings</li>
            </ul>
            <p>
              To make a data request, please email us at:{' '}
              <a href="mailto:tahoemountaincars@gmail.com">tahoemountaincars@gmail.com</a>
            </p>
          </section>

          <section className="policy-section">
            <h2>6. Data Security</h2>
            <p>
              We take reasonable measures to protect your data. However, no online transmission is 
              100% secure.
            </p>
          </section>

          <section className="policy-section">
            <h2>7. Children's Privacy</h2>
            <p>
              Our Site is not intended for children under 13. We do not knowingly collect personal 
              data from children.
            </p>
          </section>

          <section className="policy-section">
            <h2>8. Changes to This Policy</h2>
            <p>
              We may update this Privacy Policy from time to time. The most recent version will always 
              be linked from www.tahoemountaincars.com with an updated effective date.
            </p>
          </section>

          <section className="policy-section">
            <h2>9. Contact Us</h2>
            <p>For questions or concerns regarding this Privacy Policy, you can contact us at:</p>
            <p className="contact-info">
              <strong>Tahoe Mountain Cars</strong><br />
              <a href="mailto:tahoemountaincars@gmail.com">tahoemountaincars@gmail.com</a><br />
              <a href="https://www.tahoemountaincars.com">www.tahoemountaincars.com</a>
            </p>
          </section>

          <div className="back-link">
            <a href="/">← Back to Home</a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;